"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mathPlugin = mathPlugin;

var _inline = require("./inline.js");

var _inline2 = _interopRequireDefault(_inline);

var _block = require("./block.js");

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function mathPlugin() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _block2.default.call(this, opts);
  _inline2.default.call(this, opts);
}

var _default = mathPlugin;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mathPlugin, "mathPlugin", "src/remark-math/index.js");
  reactHotLoader.register(_default, "default", "src/remark-math/index.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/markdown/lib/remark-math/index.js
// module id = 198
// module chunks = 186292428941015